class ProductAccordion extends HTMLElement {
  constructor() {
    super();
    this.desktopBreakpoint = 1024;
  }

  connectedCallback() {
    this.firstTab = this.querySelector('.product__accordion--first');

    if (this.firstTab) {
      this.setCollapsibleTabState();
    }
  }

  setCollapsibleTabState() {
    const isDesktop = window.innerWidth >= this.desktopBreakpoint;

    if (this.firstTab) {
      if (isDesktop) {
        this.firstTab.setAttribute('open', '');
      } else {
        this.firstTab.removeAttribute('open');
      }
    }
  }
}

customElements.define('product-accordion', ProductAccordion);